export const setLanguageUrl = (code: string) => {
  const pathToArray = window.location.pathname.split('/');

  pathToArray[1] = code;

  return pathToArray.join('/');
};
